var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignEffect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4158_12085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33591 2.33739C2.33591 1.69055 1.81332 1.16797 1.16649 1.16797C0.519654 1.16797 -0.00292969 1.69055 -0.00292969 2.33739V14.6163C-0.00292969 16.2315 1.30536 17.5398 2.92061 17.5398H17.5383C18.1852 17.5398 18.7078 17.0172 18.7078 16.3704C18.7078 15.7236 18.1852 15.201 17.5383 15.201H2.92061C2.59903 15.201 2.33591 14.9379 2.33591 14.6163V2.33739ZM17.1948 5.50212C17.6516 5.04532 17.6516 4.30347 17.1948 3.84667C16.738 3.38986 15.9962 3.38986 15.5394 3.84667L11.6912 7.69844L9.59361 5.60079C9.1368 5.14399 8.39495 5.14399 7.93815 5.60079L3.84519 9.69376C3.38838 10.1506 3.38838 10.8924 3.84519 11.3492C4.30199 11.806 5.04384 11.806 5.50064 11.3492L8.7677 8.08581L10.8653 10.1835C11.3222 10.6403 12.064 10.6403 12.5208 10.1835L17.1985 5.50578L17.1948 5.50212Z",
    fill: "#0066CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4158_12085"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18.7107V18.7107H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignEffect);
export default __webpack_public_path__ + "static/media/campaign_effect.f96849fea4fd5b3acd8bf040cdf03dca.svg";
export { ForwardRef as ReactComponent };